// src/components/Navigation.js
import React from 'react';
import { Layout, DollarSign, Briefcase, BarChart2, FileText } from 'react-feather';

const NAV_ITEMS = [
  { id: 'Income', label: 'Income', icon: DollarSign },
  { id: 'Expenses & Assets', label: 'Expenses', icon: Briefcase },
  { id: 'Investments', label: 'Investments', icon: BarChart2 },
  { id: 'Deductions & Credits', label: 'Deductions', icon: FileText },
];

// Receive activeTab and setActiveTab as props
export default function Navigation({ activeTab, setActiveTab }) {
  return (
    <nav className="sidebar-links">
      {NAV_ITEMS.map(item => {
        const Icon = item.icon;
        return (
          <a
            key={item.id}
            href="#"
            // Apply the 'active' class if the item's id matches the activeTab state
            className={`sidebar-link ${activeTab === item.id ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab(item.id); // Call the function passed from App.js
            }}
          >
            <Icon size={18} />
            <span>{item.label}</span>
          </a>
        );
      })}
    </nav>
  );
}